// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__11lJl","name":"ConsentHeader_name__2h8Fe","birthday":"ConsentHeader_birthday__2dHGG","skeleton":"ConsentHeader_skeleton__2ra1c"};